import React from "react";
import { Card, CardContent, Skeleton, Stack, Box } from "@mui/material";

const CardSkeleton = () => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: "none",
        border: "1px solid #E8E8E8",
        bgcolor: "#F5F5F5",
        height: "100%",
      }}
    >
      <CardContent>
        {/* Title + Icon Row */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width={100} height={20} />

          <Skeleton variant="circular" width={28} height={28} />
        </Stack>

        {/* Value + Percentage */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
          }}
        >
          <Skeleton variant="text" width={60} height={28} />

          <Skeleton variant="text" width={40} height={20} />
        </Box>

        {/* Breakdown rows (3 placeholder rows) */}
        <Box sx={{ mt: 1.5 }}>
          <Stack spacing={1}>
            <Skeleton variant="rectangular" width="100%" height={20} />
            <Skeleton variant="rectangular" width="100%" height={20} />
            <Skeleton variant="rectangular" width="100%" height={20} />
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardSkeleton;
